module.exports = __webpack_public_path__ + "static/img/icon_googlepay.bd6ca543.png";